import React, { useEffect, useState } from 'react'

import PopupsManager from 'react-sdk/PopupsManager';
import AppState, { POPUPS } from '@/js/AppState';
import Texts from 'react-sdk/Texts';
import clsx from 'clsx';
import SoundPlayer from 'react-sdk/SoundPlayer';
import Analytics from 'react-sdk/Vertx/Analytics';
import Button from '@/components/shared/Button/Button';
import Periods from '@/js/Periods';

import classes from './PopupPeriod.module.css'
import WaveSection from '@/components/shared/WaveSection/WaveSection';
import Rays from '@/components/shared/Rays/Rays';

const PopupPeriod = () => {
  let id = PopupsManager.getData(POPUPS.PERIOD).id
  let isEnd = PopupsManager.getData(POPUPS.PERIOD).end
  let period = AppState.period

  const [idle, setIdle] = useState(AppState.dials.currentDial === null)

  useEffect(() => {
    const evt = "PERIOD_INTRO : " + id
    Analytics.contentEventShow(evt)

    // setIdle(false)
    setIdle(true)



    return () => {
      Analytics.contentEventHide(evt)
    }
  }, []);

  function handleClose() {

    let dialId = ""
    if(isEnd) {
      switch(id) {
        case "present": dialId = "past_outro"; break;
        case "future": dialId = "present_outro"; break;
      }
    }
    else {
      dialId = `${id}_intro`
    }

    AppState.dials.playSequence("Dials", dialId, () => {
      PopupsManager.close(POPUPS.PERIOD)
    });
  }

  return (

    <div className={clsx(classes.PopupPeriod)} >
      <div className={isEnd ? classes.EndTitleSection : classes.TitleSection}>
        <div className={classes.title}>{period.title}</div>
        <div className={classes.timeframe}>{period.timeframe}</div>
      </div>
      {isEnd && <div className={classes.rays}>
        <Rays />
      </div>
      }
      <WaveSection globalClasses={`${classes.WaveSection} ${isEnd ? classes.end : null}`} contentClasses={`${classes.content} ${isEnd && classes.endContent}`} color="#fff">
        {isEnd && <div className={classes.endContent}>
          <h1 className={classes.endTitle}>{Texts.get("Period-popup-end-title")}</h1>
          <div className={classes.endDesciption} dangerouslySetInnerHTML={{ __html: period.endDesciption }} />
        </div>}
        {idle && <Button className={classes.NextBtn} onClick={handleClose}>{Texts.get("Period-popup-start")}</Button>}
      </WaveSection>
    </div>
  );
};

export default PopupPeriod;
